import React from 'react'
import Dropdowns from './dropdowns'
import Inputs from './inputs'

const CreationSourceEditorCaptionPanel = () => (
    <>
        <Dropdowns />
        <Inputs />
    </>
)

export default CreationSourceEditorCaptionPanel
